import React, { Component } from "react";
import Toast from "../toast";

const locale = ( typeof ( window.AppWizardLocale ) !== 'undefined' ? window.AppWizardLocale : false );
if ( !locale ) {
    throw new Error( 'Error: Locale not loaded' );
}

class ShoppingList extends Component {
    constructor(props) {
        super( props );

        this.createEntries = this.createEntries.bind( this );

        this.state = props.app.state;
    }

    createEntries(item, index) {
        return (
            <li key={index} className="shopping-list__item">
                <span className="shopping-list__item__quantity">{item.quantity}</span>
                <span className="shopping-list__item__type">&nbsp;{item.um}&nbsp;</span>
                <span className="shopping-list__item__product">{item.product}</span>
            </li>
        );
    }

    render() {
        let locale = this.props.locale;
        return (
            <React.Fragment>
                <ul className="shopping-list__ingredients">
                    {this.props.items.map( this.createEntries )}
                </ul>

                <p className="shopping-list__cocktail-portions">
                    {locale.texts.shopping_list_heading_700_portions_text}&nbsp;{this.props.cocktail.numar_portii_sticla_700ml}
                </p>

                {
                    this.props.cocktail.numar_portii_sticla_1000ml > 0 &&
                    <p className="shopping-list__cocktail-portions">
                        {locale.texts.shopping_list_heading_1000_portions_text}&nbsp;{this.props.cocktail.numar_portii_sticla_1000ml}
                    </p>
                }
            </React.Fragment>
        );
    }
}

export default ShoppingList;
